import { useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

const ClickOutside = ({ clickOutsideFunction, isOn = true, children, classes = '', ...rest }) => {
    const wrapperRef = useRef(null);

    const handleClickOutside = useCallback(
        (event) => {
            wrapperRef.current && !wrapperRef.current.contains(event.target) && clickOutsideFunction();
        },
        [clickOutsideFunction]
    );

    useEffect(() => {
        if (isOn) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [isOn, handleClickOutside]);

    return (
        <div ref={wrapperRef} className={classes} {...rest}>
            {children}
        </div>
    );
};

ClickOutside.propTypes = {
    clickOutsideFunction: PropTypes.func.isRequired,
    isOn: PropTypes.bool,
    children: PropTypes.node.isRequired,
    classes: PropTypes.string,
};

export default ClickOutside;
